
/// <reference path="../../../../rcwebmodels/reeferstatus.cs.d.ts" />
/// <reference path="../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../rcwebmodels/vesselstatus.cs.d.ts" />
import { fetch, addTask } from 'domain-task';
import { Action, Reducer, ActionCreator } from 'redux';
import { AppThunkAction } from './';
import { RCUtils } from './../RCUtils';

import { PopupWindow } from '../components/sharedcomponents/PopupWindow';
var Config: any = require('../Config.json');

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface VesselSearchState {
    isLoading: boolean;
    searchFilters: server.VesselSearchFilters;
    vesselStatus: server.USP_UnitCurrentConditionUI_Model[];
    vesselData: server.VesselEntityCollection;
    columnDefs: any[];
    performCargoAction: boolean;
    reeferFormatter: server.ReeferFormatter;
    reeferConfigTypes: any;
    refApplicationParams: any;
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface RequestVesselSearchAction {
    type: 'REQUEST_VESSEL_SEARCH';
    searchFilters: server.VesselSearchFilters;
    colDefs: any[];
}

interface ReceiveVesselSearchAction {
    type: 'RECEIVE_VESSEL_SEARCH_DETAILS';
    searchFilters: server.VesselSearchFilters;    
    vesselStatusData: server.USP_UnitCurrentConditionUI_Model[];
    colDefs: any[];
    performCargoAction: boolean;
    reeferFormatterData: server.ReeferFormatter;
    reeferConfigTypes: any;
    refApplicationParams: any;
}

interface ReceiveVesselDataAction {
    type: 'RECEIVE_VESSEL_DATA_DETAILS';
    searchFilters: server.VesselSearchFilters;
    vesselStatusData: server.USP_UnitCurrentConditionUI_Model[];
    vesselData: server.VesselEntityCollection;
    colDefs: any[];
    performCargoAction: boolean;
}

interface RequestAssignCargoCare {
    type: 'REQUEST_ASSIGN_CARGO_CARE';
    commandUnits: server.ReeferCommandUnits[];
}

interface RequestUnAssignCargoCare {
    type: 'REQUEST_UN_ASSIGN_CARGO_CARE';
    commandUnits: server.ReeferCommandUnits[];
}

interface RequestClearSetPoint {
    type: 'REQUEST_CLEAR_SET_POINT';
    commandUnits: server.ReeferCommandUnits[];
}
interface RequestEventMaster {
    type: 'REQUEST_EVENTMASTER';  
}
interface ReceiveEventMaster {
    type: 'RECEIVE_EVENTMASTER';
    reeferFormatterData: server.ReeferFormatter;
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
type KnownAction = RequestVesselSearchAction | ReceiveVesselSearchAction | ReceiveVesselDataAction | RequestAssignCargoCare | RequestUnAssignCargoCare | RequestClearSetPoint | RequestEventMaster | ReceiveEventMaster;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    requestVesselData: (vesselCols: any[]): AppThunkAction<KnownAction> => (dispatch, getState) => {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Vessel/GetVesselData', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.VesselEntityCollection>)
            .then(data => {
                dispatch({ type: 'RECEIVE_VESSEL_DATA_DETAILS', vesselData: data, vesselStatusData: getState().vesselStatus.vesselStatus, searchFilters: getState().vesselStatus.searchFilters, colDefs:vesselCols, performCargoAction: false });
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_VESSEL_SEARCH', searchFilters: getState().vesselStatus.searchFilters, colDefs: vesselCols });
    },
    requestVesselSearch: (searchFilters: any, vesselCols: any[]): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)      
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Vessel/GetVesselStatus', { method: 'POST', body: JSON.stringify(searchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                if (data.length > 0) {
                    if (data[0].ErrorMessage == null || data[0].ErrorMessage == "")
                        dispatch({ type: 'RECEIVE_VESSEL_SEARCH_DETAILS', searchFilters: searchFilters, vesselStatusData: data, colDefs: vesselCols, performCargoAction: false, reeferFormatterData: getState().home.reeferFormatter, reeferConfigTypes: getState().home.reeferConfigTypes, refApplicationParams: getState().home.refApplicationParams });
                         else {
                        PopupWindow.showErrorMessage("Refine Search!", "Your search returns too many results. Please refine your search.");
                        dispatch({ type: 'RECEIVE_VESSEL_SEARCH_DETAILS', searchFilters: searchFilters, vesselStatusData: [], colDefs: vesselCols, performCargoAction: false, reeferFormatterData: getState().home.reeferFormatter, reeferConfigTypes: getState().home.reeferConfigTypes, refApplicationParams: getState().home.refApplicationParams });
                    }
                }
                else
                    dispatch({ type: 'RECEIVE_VESSEL_SEARCH_DETAILS', searchFilters: searchFilters, vesselStatusData: [], colDefs: vesselCols, performCargoAction: false, reeferFormatterData: getState().home.reeferFormatter, reeferConfigTypes: getState().home.reeferConfigTypes, refApplicationParams: getState().home.refApplicationParams });

                });
        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_VESSEL_SEARCH', searchFilters: searchFilters, colDefs: vesselCols });
    },
    requestAssignCargoCare: (commandUnits: server.ReeferCommandUnits[]): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)      
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/AssignCargoCare', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                dispatch({ type: 'RECEIVE_VESSEL_SEARCH_DETAILS', searchFilters: getState().vesselStatus.searchFilters, vesselStatusData: getState().vesselStatus.vesselStatus, colDefs: getState().vesselStatus.columnDefs, performCargoAction: true, reeferFormatterData: getState().home.reeferFormatter, reeferConfigTypes: getState().home.reeferConfigTypes, refApplicationParams: getState().home.refApplicationParams });
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_ASSIGN_CARGO_CARE', commandUnits: commandUnits });
    },
    requestUnAssignCargoCare: (commandUnits: server.ReeferCommandUnits[]): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)      
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/UnAssignCargoCare', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                dispatch({ type: 'RECEIVE_VESSEL_SEARCH_DETAILS', searchFilters: getState().vesselStatus.searchFilters, vesselStatusData: getState().vesselStatus.vesselStatus, colDefs: getState().vesselStatus.columnDefs, performCargoAction: true, reeferFormatterData: getState().home.reeferFormatter,reeferConfigTypes: getState().home.reeferConfigTypes, refApplicationParams: getState().home.refApplicationParams });
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_UN_ASSIGN_CARGO_CARE', commandUnits: commandUnits });
    },
    requestClearSetPoint: (commandUnits: server.ReeferCommandUnits[]): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)      
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ClearSetPoint', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                dispatch({ type: 'RECEIVE_VESSEL_SEARCH_DETAILS', searchFilters: getState().vesselStatus.searchFilters, vesselStatusData: getState().vesselStatus.vesselStatus, colDefs: getState().vesselStatus.columnDefs, performCargoAction: true, reeferFormatterData: getState().home.reeferFormatter, reeferConfigTypes: getState().home.reeferConfigTypes, refApplicationParams: getState().home.refApplicationParams });
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_CLEAR_SET_POINT', commandUnits: commandUnits });
    },
    requestEventMaster: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)      
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.ReeferFormatter>)
            .then(data => {
                dispatch({ type: 'RECEIVE_EVENTMASTER', reeferFormatterData: data });
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_EVENTMASTER' });
    }
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
const emptySearchFilter = { VesselId: '', VoyageId: '', PortOfDeparture: '', PortOfDestination: '', AllReefers: '' }
const emptyVesselData = { VesselIDList: [], VoyageIDList: [], PortOfDepartureList: [], PortOfDestinationList: [] }
const unloadedState: VesselSearchState = { isLoading: false, searchFilters: emptySearchFilter, vesselStatus: [], vesselData: emptyVesselData, columnDefs: [], performCargoAction: false, reeferFormatter: null, reeferConfigTypes: null, refApplicationParams: null };

export const reducer: Reducer<VesselSearchState> = (state: VesselSearchState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'REQUEST_VESSEL_SEARCH':
            return {
                searchFilters: action.searchFilters,
                vesselStatus: state.vesselStatus,
                vesselData: state.vesselData,
                isLoading: true,
                columnDefs: action.colDefs,
                performCargoAction: false,
                reeferFormatter: state.reeferFormatter,
                reeferConfigTypes: state.reeferConfigTypes,
                refApplicationParams : state.refApplicationParams
            };
        case 'RECEIVE_VESSEL_DATA_DETAILS':
            return {
                searchFilters: action.searchFilters,
                vesselStatus: state.vesselStatus,
                vesselData: action.vesselData,
                isLoading: false,
                columnDefs: action.colDefs,
                performCargoAction: false,
                reeferFormatter: state.reeferFormatter,
                reeferConfigTypes: state.reeferConfigTypes,
                refApplicationParams: state.refApplicationParams
            };
        case 'REQUEST_ASSIGN_CARGO_CARE':
            return {
                searchFilters: state.searchFilters,
                vesselStatus: state.vesselStatus,
                vesselData: state.vesselData,
                isLoading: false,
                columnDefs: state.columnDefs,
                performCargoAction: false,
                reeferFormatter: state.reeferFormatter,
                reeferConfigTypes: state.reeferConfigTypes,
                refApplicationParams: state.refApplicationParams
            };
        case 'REQUEST_UN_ASSIGN_CARGO_CARE':
            return {
                searchFilters: state.searchFilters,
                vesselStatus: state.vesselStatus,
                vesselData: state.vesselData,
                isLoading: false,
                columnDefs: state.columnDefs,
                performCargoAction: false,
                reeferFormatter: state.reeferFormatter,
                reeferConfigTypes: state.reeferConfigTypes,
                refApplicationParams: state.refApplicationParams
            };
        case 'REQUEST_CLEAR_SET_POINT':
            return {
                searchFilters: state.searchFilters,
                vesselStatus: state.vesselStatus,
                vesselData: state.vesselData,
                isLoading: false,
                columnDefs: state.columnDefs,
                performCargoAction: false,
                reeferFormatter: state.reeferFormatter,
                reeferConfigTypes: state.reeferConfigTypes,
                refApplicationParams: state.refApplicationParams
            };
        case 'REQUEST_EVENTMASTER':
            return {
                reeferFormatter: state.reeferFormatter,
                searchFilters: state.searchFilters,
                vesselStatus: state.vesselStatus,
                vesselData: state.vesselData,
                isLoading: true,
                columnDefs: state.columnDefs,
                performCargoAction: false,
                reeferConfigTypes: state.reeferConfigTypes,
                refApplicationParams: state.refApplicationParams
            };
        case 'RECEIVE_EVENTMASTER':
            return {
                reeferFormatter: action.reeferFormatterData,
                searchFilters: state.searchFilters,
                vesselStatus: state.vesselStatus,
                vesselData: state.vesselData,
                isLoading: false,
                columnDefs: state.columnDefs,
                performCargoAction: false,
                reeferConfigTypes: state.reeferConfigTypes,
                refApplicationParams: state.refApplicationParams
            };
        case 'RECEIVE_VESSEL_SEARCH_DETAILS':
            // Only accept the incoming data if it matches the most recent request. This ensures we correctly
            // handle out-of-order responses.
            if (action.searchFilters === state.searchFilters) {
                return {
                    searchFilters: action.searchFilters,
                    vesselStatus: action.vesselStatusData,
                    vesselData: state.vesselData,
                    isLoading: false,
                    columnDefs: action.colDefs,
                    performCargoAction: action.performCargoAction,
                    reeferFormatter: state.reeferFormatter,
                    reeferConfigTypes: action.reeferConfigTypes,
                    refApplicationParams: action.refApplicationParams
                };
            }
            break;
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    return state || unloadedState;
};
